import { api, flashMessage } from '../util';

(function ($) {
	/****************** Setting category ****************/
	$(document).on('change', '.procedure-category-form select[name=category]', function (e) {
		let select = $(this);
		let form = select.parents('form');
		let category = select.val();

		if (category === null || category === '') {
			return false;
		}

		let categoryTrimmed = category.trim();

		if (categoryTrimmed.length === 0) {
			return false;
		}

		select.prop('disabled', true);
		processApiRequest(form).always(function () {
			select.prop('disabled', false);
		});

		return false;
	});

	let processApiRequest = function (form) {
		let url = getApiUrlFromForm(form);
		let data = getDataFromForm(form);

		return api.post(url, data).done(function (response) {
			processApiResponse(response, form);
		});
	};

	let getDataFromForm = function (form) {
		return {
			category: form.find('[name=category]').val().trim(),
		};
	};

	let getApiUrlFromForm = function (form) {
		let procedureId = form.find('[name=procedureId]').val();
		return '/admin/procedures/' + encodeURIComponent(procedureId) + '/categories';
	};

	let processApiResponse = function (response, form) {
		flashMessage.show('success', 'Kategorie uložena');
	};
})(jQuery);
